import i18n from '@plugins/i18n';
import { RootState } from '@stores/models/store';
import * as Reducers from '@stores/reducers/Reducers';
import Constants from 'constants/constants';
import { Dispatch } from 'redux';

export const appReady =
  () =>
  (dispatch: Dispatch): void => {
    setTimeout(
      () => dispatch({ type: Reducers.READY }),
      Constants.Delays.APP_READY_DELAY,
    );
  };

export const initApp =
  () =>
  (dispatch: Dispatch): void => {
    appReady()(dispatch);
  };

export const setActivePage =
  (page: string): ((dispatch: Dispatch, getState: () => RootState) => void) =>
  (dispatch, getState): void => {
    document.title =
      i18n.t('pages.' + page + '.title') +
      ' - ' +
      i18n.t(getState().system.title);
    dispatch({ type: Reducers.SET_ACTIVE_PAGE, payload: { active: page } });
  };
